// get element for a provided file input
export const getFileFieldInfoEl = ($input, userFields) => {
  const fieldName = $input.attr('name');
  const userField = userFields[fieldName];
  $input.val(userField);

  let $fieldInfo = $input.parent().find('.form_file_field_info');
  if (userField) {
    const links = userField.split(',');
    
    const linksTemplate = links.map((link) => {
      return `<div><a href="${link}" target="_blank">${link}</a><div>`;
    }).join('');

    const template = `
      <div class="form_file_field_info">
        <div>Currently uploaded file(s):</div>
        ${linksTemplate}
      </div>
    `;
    $fieldInfo = $(template);
  } else {
    $fieldInfo = $('<div class="form_file_field_info">No file uploaded yet.</div>');
  }

  return $fieldInfo;
}

// update phone field value to format as (xxx) xxx-xxxx
export const onPhoneValueChange = ($input) => {
  const value = $input.val();
  if (value === '') return;

  const cleanedValue = value.replace(/\D/g, '');

  let formattedValue;
  if (cleanedValue.length === 0) {
    formattedValue = '';
  } else if (cleanedValue.length <= 3) {
    formattedValue = `(${cleanedValue}`;
  } else if (cleanedValue.length > 3 && cleanedValue.length <= 6) {
    formattedValue = `(${cleanedValue.slice(0, 3)}) ${cleanedValue.slice(3)}`;
  } else if (cleanedValue.length > 6) {
    formattedValue = `(${cleanedValue.slice(0, 3)}) ${cleanedValue.slice(3, 6)}-${cleanedValue.slice(6)}`;
  }
  $input.val(formattedValue.slice(0, 14));
}

export const onMoneyValueChange = ($input) => {
  const value = $input.val();
  if (value === '') return;

  const cleanedValue = value.replace(/\D/g, '');

  let formattedValue;
  if (cleanedValue.length === 0) {
    formattedValue = '';
  } else {
    // add commas to separate thousands
    const cleanedValueLength = cleanedValue.length;
    let cleanedValueWithCommas = '';
    for (let i = 0; i < cleanedValueLength; i++) {
      if (i > 0 && i % 3 === 0) {
        cleanedValueWithCommas = `${cleanedValue.charAt(cleanedValueLength - i - 1)},${cleanedValueWithCommas}`;
      } else {
        cleanedValueWithCommas = `${cleanedValue.charAt(cleanedValueLength - i - 1)}${cleanedValueWithCommas}`;
      }
    }
    formattedValue = `$${cleanedValueWithCommas}`;
  }
  $input.val(formattedValue);
}

// same as money but without $
export const onNumberValueChange = ($input) => {
  onMoneyValueChange($input);
  $input.val($input.val().replace('$', ''));
}

// validate phone number
export const validatePhone = (phone) => {
  // don't throw error if phone is empty to account for optional fields
  if (!phone) return true;
  const cleanedValue = phone.replace(/\D/g, '');
  return cleanedValue.length === 10 && !isNaN(+cleanedValue);

  // const phoneRegex = /^\d{3}-\d{3}-\d{4}$/;
  // const phoneRegex = ^\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}$;
  // return phoneRegex.test(phone);
}

// validate email
export const validateEmail = (email) => {
  // don't throw error if phone is empty to account for optional fields
  if (!email) return true;

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

// validate value is not blank
export const validateRequiredInput = (value) => {
  return value.trim() !== '';
}

// validate value is a number
export const validateNumber = (value) => {
  // don't throw error if phone is empty to account for optional fields
  if (!value) return true;

  return !isNaN(value) && value >= 0;
}

export const validateMoneyNumber = (value) => {
  // don't throw error if phone is empty to account for optional fields
  if (!value) return true;

  const cleanedValue = value.replace('$', '').replace(',', '');

  return !isNaN(cleanedValue) && cleanedValue >= 0;
}

// validate checkbox is checked
export const validateCheckbox = ($input) => {
  return $input.prop('checked');
}

// validate a radio input within a group is checked
export const validateRadio = ($inputs) => {
  if (typeof $inputs === 'string') { return true; }
  if ($inputs.length === 0 || (!$inputs.attr || $inputs.attr('type') !== 'radio')) return true;
  return $inputs.filter(':checked').length > 0;
}

// validate date is greater than min date
export const validateMinDate = (value, minDate) => {
  const valueDate = (new Date(value)).getTime();
  const minDateDate = (new Date(minDate)).getTime();

  return valueDate >= minDateDate;
};

// validate date is less than max date
export const validateMaxDate = (value, maxDate) => {
  const valueDate = (new Date(value)).getTime();
  const maxDateDate = (new Date(maxDate)).getTime();

  return valueDate <= maxDateDate;
};

export const validators = {
  phone: { validate: validatePhone, message: 'Please enter a valid phone number' },
  email: { validate: validateEmail, message: 'Please enter a valid email address' },
  required: { validate: validateRequiredInput, message: 'This field is required' },
  number: { validate: validateNumber, message: 'Please enter a number greater or equal to 0' },
  money: { validate: validateMoneyNumber, message: 'Please enter a number greater or equal to 0' },
  checkbox: { validate: validateCheckbox, message: 'This field must be checked' },
  radio: { validate: validateRadio, message: 'Please select an option' },
  minDate: { validate: validateMinDate, message: 'This date is not allowed. Please enter a later date.' },
  maxDate: { validate: validateMaxDate, message: 'This date is not allowed. Please enter an earlier date.' },
};

export const validationMessages = {
  phone: 'Please enter a valid phone number',
  email: 'Please enter a valid email address',
  required: 'This field is required',
  number: 'Please enter a number',
  checkbox: 'This field must be checked',
};
